import { Button } from '@kanda-libs/ks-design-library';
import AmountToBorrow from './AmountToBorrow';
import MonthlyPayment from './MonthlyPayment';
import useFields from './useFields';

const Fields: React.FunctionComponent = function () {
  const { type } = useFields();
  return (
    <div className="flex flex-row gap-x-3">
      <div className="flex flex-col text-left w-full">
        {type === 'monthlyPayments' ? <AmountToBorrow /> : <MonthlyPayment />}
      </div>
      <Button.Text
        id="finance-form-submit"
        label="Calculate"
        size={40}
        className="mb-auto mt-8"
        submit
      />
    </div>
  );
};

export default Fields;
